/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import useTownController from '../../../hooks/useTownController';
import { useInteractable } from '../../../classes/TownController';
import { BookSearchBar } from './BookSearchBar';
import './Library.css';

/**
 * The BookSearchViewer does the following:
 * -- monitors the player's interaction with a BookSearchArea on the map
 * -- displays the search popup for a books when player is interacting
 */

export default function BookSearchViewer(): JSX.Element {
  const coveyTownController = useTownController();
  const bookSearch = useInteractable('bookSearchArea');
  const isOpen = bookSearch !== undefined;

  useEffect(() => {
    if (bookSearch) {
      coveyTownController.pause();
    } else {
      coveyTownController.unPause();
    }
  }, [coveyTownController, bookSearch]);

  const closeModal = useCallback(() => {
    if (bookSearch) {
      coveyTownController.interactEnd(bookSearch);
    }
  }, [coveyTownController, bookSearch]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        closeModal();
        coveyTownController.unPause();
      }}>
      <ModalOverlay />
      <ModalContent className='wrapper'>
        <ModalHeader className='heading'> Welcome to the Covey.Town Library </ModalHeader>
        <BookSearchBar />
      </ModalContent>
    </Modal>
  );
}
